"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
// @ts-nocheck
var MediaDeviceInfoShim = /** @class */ (function () {
    function MediaDeviceInfoShim(options) {
        Object.defineProperties(this, {
            deviceId: { get: function () { return options.deviceId; } },
            groupId: { get: function () { return options.groupId; } },
            kind: { get: function () { return options.kind; } },
            label: { get: function () { return options.label; } },
        });
    }
    return MediaDeviceInfoShim;
}());
exports.default = MediaDeviceInfoShim;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVkaWFkZXZpY2VpbmZvLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vbGliL3R3aWxpby9zaGltcy9tZWRpYWRldmljZWluZm8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7OztHQUlHO0FBQ0gsY0FBYztBQUNkO0lBQ0UsNkJBQVksT0FBTztRQUNqQixNQUFNLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxFQUFFO1lBQzVCLFFBQVEsRUFBRSxFQUFFLEdBQUcsZ0JBQUssT0FBTyxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ2hELE9BQU8sRUFBRSxFQUFFLEdBQUcsZ0JBQUssT0FBTyxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQzlDLElBQUksRUFBRSxFQUFFLEdBQUcsZ0JBQUssT0FBTyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ3hDLEtBQUssRUFBRSxFQUFFLEdBQUcsZ0JBQUssT0FBTyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFO1NBQzNDLENBQUMsQ0FBQztJQUNMLENBQUM7SUFDSCwwQkFBQztBQUFELENBQUMsQUFURCxJQVNDO0FBRUQsa0JBQWUsbUJBQW1CLENBQUMifQ==